import Vue from 'vue';

import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

import {
    faUser,
    faEnvelope,
    faLock,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faArrowAltCircleLeft,
    faArrowAltCircleRight,
    faArrowCircleLeft,
    faArrowCircleRight,
    faEdit,
    faArrowAltCircleDown,
    faArrowAltCircleUp,
    faCloud,
    faFolder,
    faFan,
    faFilePdf,
    faCheckCircle,
    faFile,
    faFileAlt,
    faCompressArrowsAlt,
    faArrowsAlt,
    faWindowClose,
    faPencilAlt,
    faPen,
    faSave,
    faRoute,
    faImage,
    faTimes,
    faTabletAlt,
    faMap,
    faCaretUp,
    faFileSignature,
    faClock,
    faPlaneDeparture,
    faCaretSquareUp,
    faHandPointUp,
    faSignInAlt,
    faPowerOff,
    faArrowDown,
    faArrowUp,
    faStickyNote,
    faSquareFull,
    faBellSlash,
    faConciergeBell,
    faUpload,
    faFileUpload,
    faFileArchive,
    faExclamationCircle,


} from '@fortawesome/free-solid-svg-icons';

library.add(
    faUser,
    faEnvelope,
    faLock,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faArrowAltCircleLeft,
    faArrowAltCircleRight,
    faArrowCircleLeft,
    faArrowCircleRight,
    faEdit,
    faArrowAltCircleDown,
    faArrowAltCircleUp,
    faCloud,
    faFolder,
    faFan,
    faFilePdf,
    faCheckCircle,
    faFile,
    faFileAlt,
    faCompressArrowsAlt,
    faArrowsAlt,
    faWindowClose,
    faPencilAlt,
    faPen,
    faSave,
    faRoute,
    faImage,
    faTimes,
    faTabletAlt,
    faMap,
    faCaretUp,
    faFileSignature,
    faClock,
    faPlaneDeparture,
    faCaretSquareUp,
    faHandPointUp,
    faSignInAlt,
    faPowerOff,
    faArrowDown,
    faArrowUp,
    faStickyNote,
    faSquareFull,
    faBellSlash,
    faConciergeBell,
    faUpload,
    faFileUpload,
    faFileArchive,
    faExclamationCircle,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
